import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Mic, MessageCircle, Sigma, BarChart3 } from "lucide-react";

const items = [
  { to: "/dashboard", label: "Home", icon: Home, testid: "nav-home" },
  { to: "/voice", label: "Voice", icon: Mic, testid: "nav-voice" },
  { to: "/tutor", label: "Tutor", icon: MessageCircle, testid: "nav-tutor" },
  { to: "/math", label: "Math", icon: Sigma, testid: "nav-math" },
  { to: "/progress", label: "Progress", icon: BarChart3, testid: "nav-progress" },
];

export default function BottomNav() {
  const loc = useLocation();
  const hide = ["/", "/splash", "/login", "/onboarding", "/auth/callback"].includes(loc.pathname) || loc.pathname.startsWith("/creator") || loc.pathname.startsWith("/teacher");
  if (hide) return null;
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-40 border-t-2 border-gray-200 bg-white shadow-[0_-4px_20px_rgba(0,0,0,0.05)]"
    >
      <ul className="grid grid-cols-5 max-w-xl mx-auto">
        {items.map((it) => (
          <li key={it.to}>
            <NavLink
              to={it.to}
              data-testid={it.testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-2.5 gap-0.5 text-xs font-bold ${
                  isActive ? "text-[#1CB0F6]" : "text-gray-500"
                }`
              }
            >
              <it.icon strokeWidth={2.5} className="w-6 h-6" />
              <span>{it.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
